import React, { useState, useEffect } from "react";
import Footer from "../../footer";
import AdminSidebar from "../sidebar";
import { getDataWithTypeForSelect } from "../../../lib/parameters";
import { addData, updateData, getIdData } from "../../../lib/collegelistinfo";

import { useNavigate, useParams } from "react-router-dom";
import { CollegeRankSelect } from "../../ui/myselect";

export default function AdminCollegeListEdit() {
  const [prevData, setPrevData] = useState({
    unitid: "",
    college: "",
    state: "",
    city: "",
    type: "",
    population: 0,
    us_news_rank: "",
    grd_rate: "",
    rate: "",
    gpa_avg: "",
    sat_english: "",
    sat_math: "",
    sat_total: 0,
    in_state_tuition: 0,
    out_state_tuition: 0,
    url: "",
    net_price_calc_url: "",
  });
  console.log(prevData);

  const [parameters, setParameters] = useState();
  const [ranks, setRanks] = useState([]);
  const navigate = useNavigate();
  let { slug } = useParams();
console.log(slug);

  function getRank(key) {
    //console.log("ranks",ranks);
    if (slug !== "Add") {
      //console.log("key",key);
      const result = Object.entries(ranks).filter(
        (item) => item[0] === key.toString()
      );
      //console.log("key",result);
      return result[0][1];
    } else return null;
  }

  async function GetParameterData() {
    const parameterData = await getDataWithTypeForSelect("DESIRED_COLLEGES");
    setParameters(parameterData);
  }

  async function GetData(id) {
    const collage = await getIdData(id);
    setPrevData(collage[0]) 

    GetParameterData();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (slug === "Add") {
      console.log("Add");
      await addData(
        prevData
      );
    } else {
      console.log("Update");
      await updateData(
        prevData
      );
    }

    navigate("/admin/admin-collegelistinfo");
  };

  useEffect(() => {
    //navigate("/admin-params");
    if (slug !== "Add") {
      GetData(slug);
    } else {
      GetParameterData();
    }
  }, [slug]);

  return (
    <div className="col-xl-9 col-md-8">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-0">
          <div className="profile-heading">
            <h3>{slug === "Add" ? "Add College" : "Update College"}</h3>
          </div>
          <div className="checkout-form personal-address add-course-info ">
            <div className="row mx-auto">
              <form method="post" onSubmit={handleSubmit}>
                <div className="col-9">
                  <div className="form-group">
                    <h6>PHYSICAL SETTINGS</h6>
                    <label className="form-control-label">UNIT ID</label>
                    <input
                      type="text"
                      name="unitid"
                      value={prevData.unitid}
                      onChange={(e) =>
                        setPrevData({ ...prevData, unitid: e.target.value })
                      }
                      className="form-control"
                      placeholder="UnitId"
                      required
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">COLLEGE</label>
                    <input
                      type="text"
                      name="college"
                      value={prevData.college}
                      onChange={(e) =>
                        setPrevData({ ...prevData, college: e.target.value })
                      }
                      className="form-control"
                      placeholder="College"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">STATE</label>
                    <input
                      type="text"
                      name="state"
                      value={prevData.state}
                      onChange={(e) =>
                        setPrevData({ ...prevData, state: e.target.value })
                      }
                      className="form-control"
                      placeholder="State"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">CITY</label>
                    <input
                      type="text"
                      name="city"
                      value={prevData.city}
                      onChange={(e) =>
                        setPrevData({ ...prevData, city: e.target.value })
                      }
                      className="form-control"
                      placeholder="City"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">TYPE</label>
                    <input
                      type="text"
                      name="type"
                      value={prevData.type}
                      onChange={(e) =>
                        setPrevData({ ...prevData, type: e.target.value })
                      }
                      className="form-control"
                      placeholder="Type"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">POPULATION</label>
                    <input
                      type="number"
                      name="population"
                      value={prevData.population}
                      onChange={(e) =>
                        setPrevData({ ...prevData, population: e.target.value })
                      }
                      className="form-control"
                      placeholder="Population"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">US NEWS RANK</label>
                    <input
                      type="text"
                      name="us_news_rank"
                      value={prevData.us_news_rank}
                      onChange={(e) =>
                        setPrevData({
                          ...prevData,
                          us_news_rank: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="US News Rank"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">
                      GRADUATION RATE
                    </label>
                    <input
                      type="text"
                      name="grd_rate"
                      value={prevData.grd_rate}
                      onChange={(e) =>
                        setPrevData({ ...prevData, grd_rate: e.target.value })
                      }
                      className="form-control"
                      placeholder="Graduation Rate"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">RATE</label>
                    <input
                      type="text"
                      name="rate"
                      value={prevData.rate}
                      onChange={(e) =>
                        setPrevData({ ...prevData, rate: e.target.value })
                      }
                      className="form-control"
                      placeholder="Rate"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">GPA AVERAGE</label>
                    <input
                      type="text"
                      name="gpa_avg"
                      value={prevData.gpa_avg}
                      onChange={(e) =>
                        setPrevData({ ...prevData, gpa_avg: e.target.value })
                      }
                      className="form-control"
                      placeholder="GPA Average"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">SAT ENGLISH</label>
                    <input
                      type="text"
                      name="sat_english"
                      value={prevData.sat_english}
                      onChange={(e) =>
                        setPrevData({
                          ...prevData,
                          sat_english: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="SAT English"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">SAT MATH</label>
                    <input
                      type="text"
                      name="sat_math"
                      value={prevData.sat_math}
                      onChange={(e) =>
                        setPrevData({ ...prevData, sat_math: e.target.value })
                      }
                      className="form-control"
                      placeholder="SAT Math"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">SAT TOTAL</label>
                    <input
                      type="number"
                      name="sat_total"
                      value={prevData.sat_total}
                      onChange={(e) =>
                        setPrevData({ ...prevData, sat_total: e.target.value })
                      }
                      className="form-control"
                      placeholder="SAT Total"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">
                      IN-STATE TUITION
                    </label>
                    <input
                      type="number"
                      name="in_state_tuition"
                      value={prevData.in_state_tuition}
                      onChange={(e) =>
                        setPrevData({
                          ...prevData,
                          in_state_tuition: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="In-State Tuition"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">
                      OUT-OF-STATE TUITION
                    </label>
                    <input
                      type="number"
                      name="out_state_tuition"
                      value={prevData.out_state_tuition}
                      onChange={(e) =>
                        setPrevData({
                          ...prevData,
                          out_state_tuition: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="Out-of-State Tuition"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">URL</label>
                    <input
                      type="text"
                      name="url"
                      value={prevData.url}
                      onChange={(e) =>
                        setPrevData({ ...prevData, url: e.target.value })
                      }
                      className="form-control"
                      placeholder="URL"
                    />
                  </div>
                </div>
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">
                      NET PRICE CALCULATION URL
                    </label>
                    <input
                      type="text"
                      name="net_price_calc_url"
                      value={prevData.net_price_calc_url}
                      onChange={(e) =>
                        setPrevData({
                          ...prevData,
                          net_price_calc_url: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="Net Price Calculation URL"
                    />
                  </div>
                </div>
                <div className="update-profile d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    {slug === "Add" ? "Add Parameter" : "Update Parameter"}
                  </button>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="btn btn-black btn-sm"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
